import { AlertDangerIcon, Button, css, Feedback, Inline, styled } from 'canoe';
import { Field, FieldAttributes, Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import { ValueBox, ValueInput } from '@candu-ai/craft/ui';

const InlineMessage = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: ${theme.spaces.xxs};
  `}
`;

const validationSchema = Yup.object().shape({
  href: Yup.string()
    .matches(/^(?!(http | https):\/\/).*\..+/, 'Enter a valid URL')
    .required('Must specify a domain'),
});

interface Props {
  onSelectImage: (url: string) => void;
}

export const ImageLinkForm = ({ onSelectImage }: Props) => {
  const onSubmit = ({ href }: { href: string }) => {
    onSelectImage(href.includes('http') ? href : `https://${href}`);
  };

  return (
    <Formik onSubmit={onSubmit} initialValues={{ href: '' }} validationSchema={validationSchema}>
      {({ submitForm }) => (
        <Form>
          <Inline space="xs">
            <Field name="href">
              {({ field, meta }: FieldAttributes<any>) => (
                <>
                  <ValueBox label="https://">
                    <ValueInput
                      {...field}
                      data-cy="image-node-src-input"
                      placeholder="www.example.com"
                      hasError={meta.touched && meta.error}
                      data-craft-ignore-events
                      css={{ width: '200px' }}
                    />
                  </ValueBox>
                  {meta.touched && meta.error && (
                    <InlineMessage>
                      <AlertDangerIcon size="s" color="Danger" />
                      <Feedback ml="xxs" color="danger">
                        {meta.error}
                      </Feedback>
                    </InlineMessage>
                  )}
                </>
              )}
            </Field>
            <Button
              data-cy="image-node-add-button"
              variant="secondary"
              size="small"
              data-craft-ignore-events
              onClick={submitForm}
            >
              Add
            </Button>
          </Inline>
        </Form>
      )}
    </Formik>
  );
};
